import { createPreference, fetchPreferenceByKey } from '@creditsights/api-ui-web';
import { useQuery, UseQueryResult } from 'react-query';
import { PreferencesKey } from '../../services/services.constants';
import { queryKeys } from '../queryKeyFactory';

export default (enabled: boolean): UseQueryResult<boolean, Error> => {
  return useQuery<boolean, Error>(
    queryKeys.firstLogin.byPath(enabled),
    async () => {
      try {
        const firstLogin = await fetchPreferenceByKey<boolean>(PreferencesKey.firstLogin);
        return firstLogin.value;
      } catch (error: any) {
        if (error.request?.status === 404) {
          await createPreference<boolean>({ key: PreferencesKey.firstLogin, value: false });
          return true;
        }

        throw error;
      }
    },
    { cacheTime: Infinity, enabled }
  );
};
